import state from './state';
import sign from '../mixins/http/sign';

const mutations = {};

Object.keys(state).map(key => {
  mutations[`set${key.replace(/^[a-z]/i, s => s.toUpperCase())}`] = (state, value) => state[key] = value;
});

const signMutations = {};
// 加密保存的数据
[].map(k => {
  signMutations[`set${k.replace(/^[a-z]/i, s => s.toUpperCase())}`] = (state, value) => state[k] = sign.base64_encode(JSON.stringify(value));
});

const SetSession = (state, value, prop, key) => {
  try {
    if (value) {
      let str = JSON.stringify(value);
      sessionStorage.setItem(prop, str);
    } else {
      sessionStorage.removeItem(prop);
    }
  } catch (e) {
  }
  return state[key] = value || null;
};

Object.assign(mutations, signMutations, {
  setCurrAudio(state, audio) {
    return SetSession(state, audio, 'audio', 'currAudio');
  },
  setShowUserGift(state, gift) {
    return SetSession(state, gift, 'gift', 'showUserGift');
  },
});

export default mutations;
